export const loginDefault = {
  login: {
    value: "",
    isTouched: false,
    // at least 2 characters long
    validation: /.{2,}/,
    isValid: true
  },
  password: {
    value: "",
    isTouched: false,
    // at least 6 characters long
    validation: /.{6,}/,
    isValid: true
  }
};
